import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../services/notification.service';
import { Observable } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

import { CpScopeOfWork, DownloadCpSOW, DownloadMcpSOW, McpScopeOfWork, OfflineActionTypes } from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentCpId, getCurrentMcpId, getCurrentProject } from '@completion/selectors';
import { OfflineService } from '../../services/offline.service';
import { Project } from '@completion/models';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class OfflineEffects {
  constructor(
    private actions$: Actions,
    private offlineService: OfflineService,
    private store: Store<State>,
    private toastr: NotificationService,
  ) {}

  downloadMcpSOW$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DownloadMcpSOW>(OfflineActionTypes.DownloadMcpSOW),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>, this.store.select(getCurrentMcpId) as Observable<number>),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.offlineService,
        method: 'downloadMcpSOW',
        serviceArgs: ([action, currentProject, mcpId]) => [currentProject.id, mcpId, action.sowToDownload.map((s) => s.id)],
        onSuccess: () => new McpScopeOfWork(),
      }),
    ),
  );

  downloadCpSOW$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DownloadCpSOW>(OfflineActionTypes.DownloadCpSOW),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>, this.store.select(getCurrentCpId) as Observable<number>),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.offlineService,
        method: 'downloadCpSOW',
        serviceArgs: ([action, currentProject, cpId]) => [currentProject.id, cpId, action.sowToDownload.map((s) => s.id)],
        onSuccess: () => new CpScopeOfWork(),
      }),
    ),
  );
}
